import { Box, Container, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useMutation } from "react-query";
import { AccountOnboardingStep, AccountService } from "../../../api/psc";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { updateAccountOnboardingStep } from "../../../slices/SharedSlice";
import { useTutorialContext } from "../../tutorialModule/TutorialContext";
import { ActionButtons } from "../components/ActionButtons";
import { ContactInfo } from "../components/ContactInfo";
import { WelcomeSection } from "../components/WelcomeSection";

export default function Gift() {
    const dispatch = useAppDispatch();
    const { stopTutorial } = useTutorialContext();

    const doTutorial = useMutation({
        mutationFn: () =>
            AccountService.updateOnboarding("1", {
                step: AccountOnboardingStep.DONE,
            }),
        onSuccess: () => {
            dispatch(updateAccountOnboardingStep());
            stopTutorial();
        },
    });

    const reciveGift = useMutation({
        mutationFn: () =>
            AccountService.updateOnboarding("1", {
                step: AccountOnboardingStep.GIFT,
            }),
        onSuccess: () => {
            doTutorial.mutate();
        },
    });

    useEffect(() => {
        reciveGift.mutate();
    }, []);

    return (
        <Box>
            {/* Header with Logo */}
            <Box component="header" sx={{ py: 4 }}>
                <Container maxWidth="lg">
                    <Box
                        component="img"
                        src="/images/logo_light.png"
                        alt="لوگو"
                        sx={{
                            height: 120,
                            width: "auto",
                            margin: "auto",
                            display: "block",
                        }}
                    />
                    <Typography variant="h2" color="#424ebc" textAlign="center">
                        پرشین سازه
                    </Typography>
                </Container>
            </Box>

            {/* Main Content */}
            <Box
                component="main"
                sx={{
                    paddingBottom: { xs: 4, md: 12 },
                    paddingTop: 4,
                }}
            >
                <Container maxWidth="md">
                    <Stack
                        spacing={2}
                        sx={{ alignItems: { xs: "center", md: "stretch" } }}
                    >
                        <WelcomeSection />
                        <ActionButtons />
                        <ContactInfo />
                    </Stack>
                </Container>
            </Box>
        </Box>
    );
}
